export default "__VITE_ASSET__BeWFfQD8__"